import React from 'react'
import { Card, Col, Row, Statistic } from 'antd'
import { ShopOutlined, AppstoreOutlined, SolutionOutlined, TeamOutlined } from '@ant-design/icons'

function DashboardView() {
  return (
    <div>
      <h3 style={{ marginBottom: 24 }}>Panel de Control</h3>
      <Row gutter={16}>
        <Col span={6}>
          <Card bordered={false} style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.05)', borderRadius: 8 }}>
            <Statistic
              title="Empresas Registradas"
              value={12}
              prefix={<ShopOutlined style={{ color: '#1890ff', marginRight: 8 }} />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.05)', borderRadius: 8 }}>
            <Statistic
              title="Módulos Activos"
              value={8}
              prefix={<AppstoreOutlined style={{ color: '#52c41a', marginRight: 8 }} />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.05)', borderRadius: 8 }}>
            <Statistic
              title="Planes Ofrecidos"
              value={4}
              prefix={<SolutionOutlined style={{ color: '#faad14', marginRight: 8 }} />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.05)', borderRadius: 8 }}>
            <Statistic
              title="Usuarios del Sistema"
              value={45}
              prefix={<TeamOutlined style={{ color: '#eb2f96', marginRight: 8 }} />}
            />
          </Card>
        </Col>
      </Row>

      <Card title="Actividad Reciente del Sistema" style={{ marginTop: 24, boxShadow: '0 4px 12px rgba(0,0,0,0.05)', borderRadius: 8 }}>
        <p>• Empresa <strong>Ryo Logística S.A.</strong> se ha registrado y suscrito al Plan Premium.</p>
        <p>• El Super-Admin actualizó el módulo de <strong>Inventarios (Storage)</strong> con nuevos permisos.</p>
        <p>• Se creó el rol <strong>Administrador de Ventas</strong> para la empresa Ryo Logística.</p>
      </Card>
    </div>
  )
}

export default DashboardView
